import { GRID_LIST_FETCH_SIZE } from '../components/shared/agGridCells';

export type GridListResult<T> = {
  rows: T[];
  totalElements: number;
};

export type GridPagingOptions = {
  page?: number;
  size?: number;
  export?: boolean;
};

/** Re-fetches when the first page is capped at GRID_LIST_FETCH_SIZE but totalElements is higher. */
export async function fetchCompleteGridList<TResult extends GridListResult<unknown>>(
  fetchPage: (size: number, exportData: boolean) => Promise<TResult>,
): Promise<TResult> {
  const initial = await fetchPage(GRID_LIST_FETCH_SIZE, false);
  const { rows, totalElements } = initial;

  if (rows.length >= totalElements || rows.length < GRID_LIST_FETCH_SIZE) {
    return initial;
  }

  return fetchPage(totalElements, totalElements > GRID_LIST_FETCH_SIZE);
}

/** Wraps a paginated list fetch so callers always receive the full result set. */
export function createCompleteGridFetcher<
  TOptions,
  TResult extends GridListResult<unknown>,
>(
  fetchPage: (options: TOptions & GridPagingOptions) => Promise<TResult>,
): (options: TOptions) => Promise<TResult> {
  return (options) =>
    fetchCompleteGridList((size, exportData) =>
      fetchPage({ ...options, page: 0, size, export: exportData }),
    );
}
